import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  MedicalRecordReleaseEvent,
  MedicalRecordReleaseIndexItem,
  StoredMedicalRecordReleaseDocument
} from '@web/csl-lib-models';
import { Observable } from 'rxjs';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

@Injectable({
  providedIn: 'root'
})
export class ClinicMedicalRecordReleaseService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }


  getClinicIndex(clinicId: number): Observable<MedicalRecordReleaseIndexItem[]> {
    return this.http.get<MedicalRecordReleaseIndexItem[]>(`${this.apiUrl}/clinics/${clinicId}/mrrIndex`);
  }

  getDocument(clinicId: number, healthRecordId: string, mrrId: number, fileKey: string): Observable<ArrayBuffer> {
    return this.http.get(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${mrrId}/documents/${fileKey}`,
      { responseType: 'arraybuffer' }
    );
    // https://stackoverflow.com/questions/46408537/angular-httpclient-http-failure-during-parsing
  }

  getEvents(clinicId: number, healthRecordId: string, medicalRecordReleaseId: number): Observable<MedicalRecordReleaseEvent[]> {
    return this.http.get<MedicalRecordReleaseEvent[]>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${medicalRecordReleaseId}/events`);
  }

  getPendingCount(clinicId: number): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/clinics/${clinicId}/mrr/pendingCount`);
  }

  getSupportingDocuments(clinicId: number, healthRecordId: string, medicalRecordReleaseId: number): Observable<StoredMedicalRecordReleaseDocument[]> {
    return this.http.get<StoredMedicalRecordReleaseDocument[]>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${medicalRecordReleaseId}/documents`);
  }

  updateStatusFromIndex(clinicId: number, healthRecordId: string, medicalRecordReleaseId: number, newState: number, comment: string): Observable<MedicalRecordReleaseIndexItem> {
    return this.http.patch<MedicalRecordReleaseIndexItem>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${medicalRecordReleaseId}/Index`, {
      'state': newState,
      'comment': comment
    });
  }


}
